import { useState } from "react";
// import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Input } from "../../components/ui-comp/input";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { cn } from "../../lib/utils";
// import { PasswordInput } from "../../components/ui-comp/password";
import { Button } from "../../components/ui/button";
import { useMutation } from "@tanstack/react-query";
import { loginUser } from "../../helpers/auth";
import { toast } from "react-toastify";
import logo from "../../assets/images/vm_logo.png";
import CheckEmailModal from "./CheckEmailModal";
function Login() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const formSchema = z.object({
    email: z
      .string({ required_error: "Email is required" })
      .min(1, { message: "Email cannot be empty" })
      .email({ message: "Invalid email format" }),
    // password: z.string().min(8, "Password must be at least 8 characters"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(formSchema), // Use Zod schema for validation
  });

  const { mutate, isPending } = useMutation({
    mutationFn: loginUser,
    onSuccess: () => {
      // localStorage.setItem("authToken", data.access_token);
      // navigate("/dashboard");
      setOpen(true);
    },
    onError: (data) => {
      // console.log(data);
      toast(data.message);
    },
  });

  const onSubmit = (data) => {
    mutate(data);
    setEmail(data?.email);
  };

  return (
    <div className="p-4 h-full">
      <div className="border-[3px] border-secondary200 rounded-lg p-[1px] w-full h-full">
        <div className="flex w-full border-2 border-dashed border-[#71788450] rounded-lg p-4 h-full">
          <div className="xl:w-1/2 w-full flex flex-col justify-center items-center bg-white xl:h-full min-h-[85vh]">
            <img src={logo} alt="logo" className="h-[40px] mr-auto" />
            <div className="border-[3px] border-secondary200 xl:w-[70%] lg:w-[50%] md:w-[70%] w-full backdrop-blur-sm bg-transparent rounded-lg md:my-auto mt-[2rem] md:px-8 px-4 py-12">
              <h2 className="font-semibold text-neutral1000 text-2xl mb-2">
                Log in to Turingtower VM
              </h2>
              <p className="text-sm text-neutral700 mb-8">
                Access your dashboard and stay on top of your security posture.
              </p>
              <form onSubmit={handleSubmit(onSubmit)} className="">
                <Input
                  label="Email Address"
                  name="email"
                  type="email"
                  register={register}
                  placeholder="Enter your email address"
                  className={cn(
                    errors.email &&
                      "border-[#e84539] focus-visible:ring-[#ec5247] ring:ring-[#FEE4E2]"
                  )}
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mb-4">
                    {errors.email.message}
                  </p>
                )}

                {/* <PasswordInput
                  label="Password"
                  name="password"
                  register={register}
                  placeholder="Enter your password"
                  className={cn(
                    errors.password &&
                      "border-[#e84539] focus-visible:ring-[#ec5247] ring:ring-[#FEE4E2]", "text-neutral1000"
                  )}
                />
                {errors.password && (
                  <p className="text-red-500 text-sm mb-4">
                    {errors.password.message}
                  </p>
                )} */}

                <div className="mt-[2rem]">
                  <Button
                    type="submit"
                    className="h-[44px] w-full"
                    loading={isPending}
                  >
                    Log in
                  </Button>
                </div>
              </form>
            </div>
          </div>
          <div className="xl:w-1/2 xl:block hidden h-[85vh] bg-bg_login bg-cover bg-no-repeat">
            {/* <img src={auth} alt="auth" className="h-[85vh] mx-auto" /> */}
          </div>
        </div>
      </div>
      <CheckEmailModal email={email} open={open} setOpen={setOpen} />
    </div>
  );
}

export default Login;
